import {
  FETCHCONFIG_SAGA,
} from './types';

const fetchAppConfig = () => ({
  type: FETCHCONFIG_SAGA,
});

export default fetchAppConfig;
